  <div class="default-block-padding text-center"
  [class.default-block-margin-top]="data.backgroundColor"
  [ngClass]="{ 'background-dark-blue': data.backgroundColor == 'darkblue', 'background-light-blue': data.backgroundColor == 'lightblue', 'background-yellow': data.backgroundColor == 'yellow', 'background-gray': data.backgroundColor == 'gray' }">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div *ngFor="let sponsor of data.sponsors" 
           [ngClass]="{ 
             'col-12 size-xl': data.sponsors.length === 1, 
             'col-6 size-xl': data.sponsors.length === 2, 
             'col-4 size-xl': data.sponsors.length === 3,
             'col-3': data.sponsors.length === 4,
             'col-2': data.sponsors.length >= 5
           }" class="d-flex justify-content-center align-items-center">
        <a href="{{sponsor.url}}" target="_blank" class="d-flex justify-content-center align-items-center">
            <img [src]="sponsor.image?.url" [alt]="sponsor.image?.alternativeText" class="img-fluid mb-5" />
        </a>
      </div>
    </div>
    </div>